import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface NotificationBannerMessage {
  type: 'success' | 'error';
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationBannerService {
  private bannerSubject = new Subject<NotificationBannerMessage>();
  public banner$ = this.bannerSubject.asObservable();

  showSuccess(title: string, message: string): void {
    this.bannerSubject.next({ type: 'success', title, message });
  }

  showError(title: string, message: string): void {
    this.bannerSubject.next({ type: 'error', title, message });
  }
}
